import { MenuItem } from "@corp-ais/omniark-ui";
import { IMenuNavSourceItem, ISideNavItem } from "./side-nav.types";

export function buildItemsFromMenu(
  items: readonly IMenuNavSourceItem[],
): ISideNavItem[] {
  return items.map((item) => buildItemFromMenuSource(item));
}

function buildItemFromMenuSource(item: IMenuNavSourceItem): ISideNavItem {
  const children = item.children?.length
    ? item.children.map((child) => buildItemFromMenuSource(child))
    : undefined;

  return {
    id: item.path,
    label: item.name,
    icon: item.icon,
    path: item.path,
    children,
  };
}

export function buildMenuItems(items: readonly ISideNavItem[]): MenuItem[] {
  return items.map((item) => ({
    id: item.id,
    label: item.label,
    icon: item.icon,
    disabled: item.disabled,
    children: item.children?.length ? buildMenuItems(item.children) : undefined,
  }));
}
